import { reactive, ref } from 'vue';
import "ant-design-vue/es/modal/style/css";
import _Modal from "ant-design-vue/es/modal";
import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
import "core-js/modules/es.array.push.js";
import { Post } from '@/api/Api';
import DMPrice from './Customer.vue';
const __default__ = {
  name: 'List',
  components: {
    DMPrice
  },
  data() {
    tableHeight: '';
  },
  setup(props, context) {
    const DMConfig = reactive({
      AppName: '',
      Width: 0,
      Height: 0,
      Columns: [{
        title: "客户代码",
        dataIndex: "customerInvoiceTo",
        customRender: record => {
          return _createVNode("a", {
            "onclick": () => {
              DMPriceref.value.Open(record.record.fId, 600, 0);
            }
          }, [_createTextVNode(" "), record.record.fCustNumber, _createTextVNode(" ")]);
        },
        width: 160
      }, {
        title: "客户名称",
        dataIndex: "fCustName"
      }, {
        title: "创建日期",
        dataIndex: "fCreatedDate",
        width: 160,
        align: 'center'
      }],
      QueryParam: {},
      DataSource: [],
      selectedRowKeys: [],
      selectedRows: [],
      loading: false,
      RowKey: 'fId',
      ForkHeight: 10,
      //表格离低高度
      IsSelect: true,
      //序时簿是否支持选择
      IsMultipleSelect: false,
      //序时簿是否多选
      QueryWhere: {
        total: 0,
        current: 1,
        pageSize: 100,
        showTotal: total => {
          return `共${total}条`;
        }
      }
    });
    const OnTableChange = (pag, filters, sorter) => {
      console.log(pag);
      DMConfig.QueryWhere.current = pag.current;
      DMConfig.QueryWhere.pageSize = pag.pageSize;
      LoadData(filters, sorter);
    };
    const onSelectChange = (selectedRowKeys, selectedRows) => {
      //console.log(selectedRowKeys)
      //console.log(selectedRows)
      DMConfig.selectedRowKeys = selectedRowKeys;
      DMConfig.selectedRows = selectedRows;
    };
    const Refresh = (bool = false) => {
      bool && (DMConfig.QueryWhere = Object.assign(DMConfig.QueryWhere, {
        current: 1
      }));
      LoadData();
    };
    const LoadData = (filters, sorter) => {
      DMConfig.loading = true;

      //DMConfig.QueryParam.SearchValue = "";
      DMConfig.QueryParam.PageNo = DMConfig.QueryWhere.current;
      DMConfig.QueryParam.PageSize = DMConfig.QueryWhere.pageSize;
      Post("dm/CustomerListAll", DMConfig.QueryParam).then(res => {
        DMConfig.DataSource = res.data.rows;
        DMConfig.QueryWhere.total = res.data.total;
        DMConfig.QueryWhere.current = res.data.current;
        DMConfig.QueryWhere.pageSize = res.data.pageSize;
        DMConfig.loading = false;
      });
    };
    const GetTableYesNoCol = record => {
      if (record.value) return _createVNode(_resolveComponent("a-tag"), {
        "color": 'rgb(5, 160, 69)'
      }, {
        default: () => [_createTextVNode(" \u662F ")]
      });else return _createVNode(_resolveComponent("a-tag"), {
        "color": 'rgb(255, 0, 51)'
      }, {
        default: () => [_createTextVNode(" \u5426 ")]
      });
    };
    const OnQuery = () => {
      DMConfig.selectedRowKeys = [];
      DMConfig.selectedRows = [];
      Refresh(true);
    };
    const OnCreate = () => {
      DMPriceref.value.Open(0, 800, 0);
    };
    const OnDelete = () => {
      let _this = this;
      let Ids = [];
      DMConfig.selectedRows.forEach(m => {
        Ids.push(Number(m.fId));
      });
      Ids = Array.from(new Set(Ids));
      if (Ids.length == 0) {
        _message.error('请选择需要删除的行!');
      } else {
        _Modal.confirm({
          title: '提示',
          centered: true,
          content: '确认要删除选中的数据吗?',
          onOk: () => {
            DMConfig.loading = true;
            Post("DM/DeleteCustomer", Ids).then(res => {
              DMConfig.loading = false;
              if (res.succeeded) {
                _message.success('删除成功');
                OnQuery();
              } else {
                _message.error('删除失败：' + res.errors);
              }
            }).catch(err => {
              _message.error('删除错误：' + err.errors);
            });
          }
        });
      }
    };
    const DateFormat = text => {
      text = text.substring(0, 10);
      //var reg=/(\d{5})(\d{2})(\d{2})/;
      //text =text.replace(reg,'$1-$2-$3');
      return text;
    };
    const DMPriceref = ref();
    return {
      DMConfig,
      OnQuery,
      OnTableChange,
      onSelectChange,
      LoadData,
      GetTableYesNoCol,
      OnCreate,
      OnDelete,
      Refresh,
      DMPriceref
    };
  },
  created() {},
  mounted() {
    let _this = this;
    _this.resetTableHeight();
    window.onresize = function () {
      _this.resetTableHeight();
    };
    this.LoadData();
  },
  methods: {
    resetTableHeight() {
      let _this = this;
      var id;
      let tHeader = null;
      if (id) {
        tHeader = document.getElementById(id) ? document.getElementById(id).getElementsByClassName("ant-table-thead")[0] : null;
      } else {
        tHeader = document.getElementsByClassName("ant-table-thead")[0];
      }
      //表格内容距离顶部的距离
      let tHeaderBottom = 0;
      if (tHeader) {
        tHeaderBottom = tHeader.getBoundingClientRect().bottom;
      }
      console.log(tHeaderBottom);

      //页面高度
      let clientHeight = document.documentElement.clientHeight;
      _this.tableHeight = clientHeight - tHeaderBottom - 112 - _this.DMConfig.ForkHeight + 'px';
      /*
      //搜索高度
      let searchBarHeight=0
      //let searchBarHeight = document.getElementById("advanced_search").clientHeight;
      //表格工具栏高度
      let tabletoolHeight = document.getElementById("table_tool").clientHeight;
      _this.tableHeight = (clientHeight - 120 -40 - (searchBarHeight + 16) - (tabletoolHeight + 32) - _this
      	.DMConfig.ForkHeight) + 'px'
      	*/
    }
  },

  watch: {
    // expand(val) {
    // 	let _this=this
    // 	setTimeout(function() {
    // 			_this.resetTableHeight();
    // 	}, 10)
    // }
  }
};
import { useCssVars as _useCssVars } from 'vue';
const __injectCSSVars__ = () => {
  _useCssVars(_ctx => ({
    "345ecdde": _ctx.tableHeight
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();
  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;